// Route -> static cover art resolver shared by RouteOg and Seo so both
// meta systems agree on the same per-page card image.
import { OG_SITE_COVERS } from "./ogStatic";
import { CONVERT_PAGES, convertBySlug } from "./seoContent";

const SITE = "https://crypt.pe";

export function coverFor(path) {
  const p = path.replace(/\/+$/, "") || "/";
  const seg = p.split("/");
  if (OG_SITE_COVERS[p]) return `${SITE}${OG_SITE_COVERS[p]}`;
  if (seg[1] === "guides" && seg[2]) return `${SITE}/guides/covers/${seg[2]}-og.jpg`;
  if (seg[1] === "accept" && seg[2]) return `${SITE}/coins/covers/${seg[2]}-og.jpg`;
  if (seg[1] === "accept-crypto-in" && seg[2]) return `${SITE}/api/og/country/${seg[2]}.png`;
  if (seg[1] === "accept-crypto-for" && seg[2]) return `${SITE}/business/covers/${seg[2]}-og.jpg`;
  if (seg[1] === "price-prediction" && seg[2]) return `${SITE}/api/og/prediction/${seg[2]}.png`;
  if (seg[1] === "versus" && seg[2]) return `${SITE}/api/og/versus/${seg[2]}.png`;
  if (seg[1] === "convert" && seg[2]) {
    const c = convertBySlug(seg[2]);
    if (c) return `${SITE}/api/og/convert/${c.slug}.png`;
  }
  if (p === "/case-study/hackastra") return `${SITE}/site/covers/case-study-hackastra-og.jpg`;
  return null;
}
